import React, { useEffect, useState } from "react";
import "./learningDashboard.css";
import {
    getBotDetailsAPI,
    getBotResolutionAPI,
    getPublishAPI,
} from "./utils/constants";
import { Col, Container, Row } from "react-bootstrap";
// import { appConfig } from "../../../utils/app.config";


import LearningDashboardSection from "./learningDashboardSection";
import CustomKASection from "./customKASection";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { useKBState } from "./customHooks/useKBState";
import KnowledgeAudit from "./knowledgeAudit";
import warwickTextLogo from "../../../assets/warwickTextLogo.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import crest from "../../../assets/crest.png";
export const formatDate = (
    date?: string | Date,
    format: string = "YYYY-MM-DD"
): string => {
    return dayjs(date || new Date()).format(format);
};

const LearningDashboard: React.FC = () => {
    const [activeTab, setActiveTab] = useState("learningDashboard");
    const [botDetailsData, setBotDetailsData] = useState<any>();
    const [loading, setLoading] = useState(false);
    const learningDashboardClick = () => setActiveTab("learningDashboard");
    const knowledgeAuditClick = () => setActiveTab("knowledgeAudit");

    const customKAClick = () => setActiveTab("customKA");
    const { val, setVal } = useKBState();

    useEffect(() => {
        getBotDetails(formatDate(), formatDate(), 10, 0);
    }, []);

    const getBotDetails = async (
        startDate: any,
        endDate: any,
        totalRecords: any,
        page: any
    ) => {
        try {
            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache"
                },
            };
            const result = await (
                await fetch(
                    `${getBotDetailsAPI}/B0001/${startDate}/${endDate}/${totalRecords}/${page}`,
                    options
                )
            ).json();
            if (result) {
                console.log("get bot details result", result);

                // getting result from bot resolution and get publish api
                const [botResolutionResult, publishResult] = await Promise.all([
                    getBotResolution(result),
                    getPublish(result),
                ]);

                // merging with both the data
                const finalBotDetailsData = result?.data.map((item1: any) => {
                    const botResolutionMatch = botResolutionResult?.find(
                        (item2: any) => item2.conversation_id === item1.conversation_id

                    );
                    console.log("botResolutionMatch", botResolutionMatch);


                    const publishMatch = publishResult?.find(
                        (p: any) => p.convid === item1.conversation_id
                    );
                    console.log("publishMatch", publishMatch);


                    return {
                        ...item1,
                        botResolution: botResolutionMatch
                            ? botResolutionMatch.bot_resolution
                            : "",
                        published: publishMatch ? publishMatch.number : "",
                        publishedContent: publishMatch ? publishMatch.content : "",
                        ActionType : publishMatch ? (publishMatch.extra_text === "new_customKb" ? "New Custom KB" : "Extra Info KB") : ("")
                            // ? publishMatch.extra_info === "Selected Extra Info" ||
                            //     publishMatch.extra_info === "New"
                            //     ? 0
                            //     : publishMatch.extra_info === "Selected Enriched Data"
                            //         ? 1
                            //         : publishMatch.extra_info === "New Custom KB"
                            //             ? 2
                            //             : 3
                            // : 3,
                        // publishedFeedback: publishMatch
                        //     ? publishMatch.reviewer_feedback === "excl"
                        //         ? 0
                        //         : publishMatch.reviewer_feedback === "avg"
                        //             ? 1
                        //             : publishMatch.reviewer_feedback === "noth"
                        //                 ? 2
                        //                 : 3
                        //     : 3,
                    };
                });

                console.log("finalBotDetailsData", finalBotDetailsData);

                // setting bot details data
                setBotDetailsData({ ...result, result: finalBotDetailsData });
                console.log("setbotdetails", botDetailsData);
                // setBotDetailsData({ result: result.data, totalRecords: result.totalRecords });
                setVal({ ...val, totalRecords: result.totalRecords });
            } else {
                console.log("get bot details result is empty",);

            }
        } catch (error) { }
    };

   const getBotResolution = async (data: any) => {
  try {

    if(!data?.data || data.data.length === 0) {
        console.log("no records for this range - skipping bot_resolution call");
        return [];
    }
    console.log("inside bot resolution..",data);

  const mapped = data.data.map((item1: any) => ({
  conversation_id: item1?.conversation_id,

  work_notes: String(
    item1?.Worknotes?.[0] ??
    item1?.workNotes?.[0] ??
    ""
  ),

  resolution_note: String(
    item1?.ResolutionNotes?.[0] ??
    item1?.resolutionNotes?.[0] ??
    ""
  ),

  additional_comments: "",
}));


console.log("Before filter:", mapped);
    const payloadData = mapped;
const jsonString = JSON.stringify(payloadData);
 
const payload = btoa(
  encodeURIComponent(jsonString).replace(
    /%([0-9A-F]{2})/g,
    (_, p1) => String.fromCharCode(parseInt(p1, 16))
  )
);
 
    // const payload = btoa(JSON.stringify(payloadData));
    // console.log("after payload assigning..", payload);

    console.log("RAW INPUT:", data.data);
    console.log("FIRST ITEM:", data.data[0]);
    const formData = new FormData();
    formData.append("actions", "bot_resolution");
    formData.append("method", "POST");
    formData.append("resolution", payload);

    const options = {
        method: "POST",
        body: formData,
    };


    console.log("passing publish api bot resolution..");

    const result = await (
      await fetch(`${getBotResolutionAPI}`, options)
    ).json();

    console.log("bot resolution result::", result);

    return result;

  } catch (error) {
    console.error("Error in bot resolution:", error);
    return [];
  }
};
    const getPublish = async (data: any) => {
        try {
            console.log("inside get publish..")
            const formData = new FormData();
            formData.append("actions", "get_publish");
            formData.append("method", "GET");
            const result = await (await fetch(`${getPublishAPI}`, {method:"POST" , body:formData})).json();
            console.log("get publish result..")
            if(result?.error){
                console.error("get_publish failed: ",result.error)
                return [];
            } 
            return result??[];
        } catch (error) { 
            console.error("Error in get publish:" , error);
            return [];
        }
    };

    const handlePageClick = (val: any, formValues: any) => {
        console.log("valie", val);
        handleFormSubmit(formValues, val - 1);
    };

    const handleXlsx = (totalRecords: any, formValues: any) => {
        console.log("valie", totalRecords, botDetailsData);
        getBotDetails(formValues.startDate, formValues.endDate, totalRecords, 0);
        if (totalRecords > 0 && botDetailsData) {
            exportToXlsx(botDetailsData.result);
        }
    };

    const exportToXlsx = (result: any) => {
        console.log("export result", result);

        function prepareData(data: any) {
            return data.map((item: any) => {
                const newItem = { ...item };

                // Handle 'info' nested fields if exist
                if (item.KB_details) {
                    // Promote is_helpful to top level 
                    //Removed this column because we do not have is_helpful configured 
                    // newItem.is_helpful =
                    //     item.KB_details.map((val: any) => val.is_helpful ?? '').join(", ");
                    // console.log("new item", newItem);
                    // Format kb_number nicely

                    newItem.kb_number = item.KB_details.map((val: any) => {
                        if (Array.isArray(val.kb_number)) {
                            return val.kb_number.join(", ")
                        } else {
                            return val.kb_number ?? "";
                        }
                    }).join(" | ");

                    delete newItem.KB_details; // Remove the original 'info' object
                }

                if (Array.isArray(item.ticket_number)) {
                    newItem.ticket_number = item.ticket_number.join(', ');
                }

                if (Array.isArray(item.ResolutionNotes)) {
                    newItem.ResolutionNotes = item.ResolutionNotes.join(' | ');
                }

                if (Array.isArray(item.transcript)) {
                    newItem.transcript = item.transcript.map((t: any) => {
                        const requester = t.requester ?? 'Unknown';
                        const timestamp = t.timestamp ? `@${t.timestamp}` : '';
                        const botresponse = t.bot_response ?? "";

                        return `[${requester} ${timestamp} ]: ${botresponse}`
                    }).join("\n");
                }



                return newItem;
            });
        }

        // Usage
        // const preparedData = prepareData(originalJson);
        // const worksheet = XLSX.utils.json_to_sheet(preparedData);

        const ws = XLSX.utils.json_to_sheet(prepareData(result));

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        const data = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
        });

        const url = window.URL.createObjectURL(data);
        const a = document.createElement("a");
        a.href = url;
        a.download = "data.xlsx";
        a.click();
        URL.revokeObjectURL(url);
    };

    const handleFormSubmit = (data: any, pageNumber: any = 0) => {
        console.log("date data", data);
        getBotDetails(data.startDate, data.endDate, 10, pageNumber);
    };

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <div className="topbar-learning">
                            <div className="topbar-inner">
                                <div className="left">
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <img src={crest} alt="crest" className="brand crest" />
                                        <img src={warwickTextLogo} alt="warwickTextLogo" className="brand logo" />
                                    </div>
                                </div>
                                <div className="topbar-title">Itika Dashboard</div>
                                <div className="right" />
                            </div>
                        </div>

                        <hr
                            style={{
                                borderTop: "2px solid black",
                                marginTop: "19px 0",
                                marginBottom: 0
                            }}
                        />

                        {/* NAVIGATION */}
                        <div
                            className="justify-content-center navbar-class"
                            style={{
                                display: "flex",
                                gap: "12px"
                            }}
                        >
                            <div
                                className={
                                    activeTab === "knowledgeAudit"
                                        ? "sel-dash-nav-button"
                                        : "dash-nav-button"
                                }
                                onClick={knowledgeAuditClick}
                            >
                                <p style={{ margin: 0 }}>Knowledge Audit</p>
                            </div>

                            <div
                                className={
                                    activeTab === "learningDashboard"
                                        ? "sel-dash-nav-button"
                                        : "dash-nav-button"
                                }
                                onClick={learningDashboardClick}
                            >
                                <p style={{ margin: 0 }}>Learning Dashboard</p>
                            </div>

                            <div
                                className={
                                    activeTab === "customKA"
                                        ? "sel-dash-nav-button"
                                        : "dash-nav-button"
                                }
                                onClick={customKAClick}
                            >
                                <p style={{ margin: 0 }}>Custom KA</p>
                            </div>
                        </div>
                        <div className="header-bottom-divider" />
                    </Col>
                </Row>
            </Container >

            <Container
                fluid
                style={{
                    margin: 0,
                    width: "-webkit-fill-available",
                    overflowY: "auto",
                    height: "-webkit-fill-available",
                    padding: "12px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                }}
            >


                <div style={{ display: activeTab === "learningDashboard" ? "block" : "none" }}>
                    <LearningDashboardSection
                        botDetailsData={botDetailsData}
                        onSubmit={handleFormSubmit}
                        onPageClick={handlePageClick}
                        exportAsXlsx={handleXlsx}
                    />
                </div>

                <div style={{ display: activeTab === "customKA" ? "block" : "none" }}>
                    <CustomKASection />
                </div>

                <div style={{ display: activeTab === "knowledgeAudit" ? "block" : "none" }}>
                    <KnowledgeAudit />
                </div>
            </Container>
        </>
    );
};

export default LearningDashboard;
